import axiosInstance from "./axiosInstance"

const url = "/prompts"

export const savePrompt = (data) => axiosInstance.post(url, data)

export const getPrompt = (name) => axiosInstance.get(url, { params: { name } })

export const getAllPrompts = () => axiosInstance.get(url)
